module.exports = __webpack_public_path__ + "static/img/logo-white.ea0afd0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logo-white.svg
// module id = mtKP
// module chunks = 4